import { useParams, useSearchParams } from "react-router-dom";

const slugToLabel = (slug = "") =>
    slug
        .replace(/-/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());

export const useProductBreadcrumbs = () => {
    const { categorySlug, subcategorySlug } = useParams();
    const [searchParams] = useSearchParams();

    // fallback from query params
    const categoryQuery = searchParams.get("categories");
    const subcategoryQuery = searchParams.get("subcategories");

    const paths = [];

    const finalCategory = categorySlug || categoryQuery;
    const finalSubcategory = subcategorySlug || subcategoryQuery;

    if (finalCategory) {
        paths.push({
            label: slugToLabel(finalCategory),
            to: `/${finalCategory}`,
        });
    }

    if (finalSubcategory && categoryQuery === null) {
        paths.push({
            label: slugToLabel(finalSubcategory),
            to: null,
        });
    }

    return paths;
};